/**
 * The one source of truth for literal color hex — mirrors the Tailwind tokens in
 * `web/tailwind.config.js`. Recharts and inline `style` need literal hex (not
 * class names), so every chart / marker / inline-styled color imports from here
 * instead of hardcoding, which keeps them from drifting out of sync with the
 * design tokens. If you change a token, change it in BOTH places.
 */
export const COLORS = {
  // Surfaces & text
  plane: "#111C20",
  surface: "#273438",
  surface2: "#31434A",
  surface3: "#3B4E56",
  ink: "#F6F6F6",
  inkSecondary: "#C6CDCF",
  muted: "#999999",
  hairline: "rgba(255,255,255,0.10)",
  // Chart chrome
  grid: "#33454C",
  axis: "#3B4E56",
  // Brand + status (reserved; never a chart series)
  brand: "#FF2E75",
  good: "#26D367",
  warning: "#F5A524",
  critical: "#F04438",
  info: "#20A7DF",
  neutral: "#999999",
  // Categorical chart series (chart lines only)
  series1: "#20A7DF",
  series2: "#26D367",
  series3: "#FF2E75",
  // Extra categorical hues (annotation-type markers only)
  violet: "#9B8AFB",
  slate: "#94A3B8",
} as const;

export type ColorToken = keyof typeof COLORS;
